function RouteLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-trading-bg text-trading-subdued">
      <div className="rounded-terminal border border-trading-border bg-trading-panel px-5 py-4 shadow-terminal-soft">
        <div className="mb-2 h-1 w-36 overflow-hidden rounded-full bg-trading-muted">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-trading-brand" />
        </div>
        <p className="m-0 text-xs font-extrabold uppercase tracking-[0.18em]">
          Loading terminal
        </p>
      </div>
    </div>
  );
}

export default RouteLoader;
